// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t3gq","left":"styles_left__3MG4R","desktopActions":"styles_desktopActions__1icEl","title":"styles_title__6_vuJ"};